import { render, staticRenderFns } from "./iranProducts.vue?vue&type=template&id=4edba425&scoped=true&"
import script from "./iranProducts.vue?vue&type=script&lang=js&"
export * from "./iranProducts.vue?vue&type=script&lang=js&"
import style0 from "./iranProducts.vue?vue&type=style&index=0&id=4edba425&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edba425",
  null
  
)

export default component.exports